module.exports = __webpack_public_path__ + "img/ships.2ddd7ef8.png";